module.exports = __webpack_public_path__ + "ios.png?7c7a960fa5ac3e5f13406cdd7b36c593";


//////////////////
// WEBPACK FOOTER
// ./static/ios.png
// module id = 5
// module chunks = 0